package com.merkost.handpass.sharedweb.components

import com.merkost.handpass.sharedweb.theme.Accent
import com.merkost.handpass.sharedweb.theme.AccentRing
import com.merkost.handpass.sharedweb.theme.Border
import com.merkost.handpass.sharedweb.theme.Danger
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import com.merkost.handpass.sharedweb.theme.HandpassTypography
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.OnSurfaceFaint
import com.merkost.handpass.sharedweb.theme.RadiusControl
import com.merkost.handpass.sharedweb.theme.Surface
import com.merkost.handpass.sharedweb.theme.Transparent
import com.merkost.handpass.sharedweb.theme.WebSize
import com.merkost.handpass.sharedweb.theme.transitionColors
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.disabled as disabledSelector
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.invalid
import com.varabyte.kobweb.silk.style.selectors.placeholder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent

val WebFieldStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Surface.value())
            .color(OnSurface.value())
            .border(WebSize.P1.value(), LineStyle.Solid, Border.value())
            .borderRadius(RadiusControl.value())
            .fontSize(HandpassTypography.Body)
            .width(100.percent)
            .outline(WebSize.P0.value(), LineStyle.None, Transparent.value())
            .styleModifier {
                property("padding", "${HandpassSpacing.MD} ${HandpassSpacing.Default}")
                property("box-sizing", "border-box")
                property("font-family", "inherit")
                property("letter-spacing", "0")
            }
            .transitionColors()
    }
    focus {
        Modifier
            .border { color(Accent.value()) }
            .boxShadow(spreadRadius = WebSize.P3.value(), color = AccentRing.value())
    }
    placeholder {
        Modifier.color(OnSurfaceFaint.value())
    }
    invalid {
        Modifier.border { color(Danger.value()) }
    }
    disabledSelector {
        Modifier.styleModifier { property("opacity", "0.5") }
    }
}
